import { type TranslationTree } from '@/i18n/types';

export const messages = {
  subjects: 'Atletas no feed',
  subjectsHint: 'autorizaram a {{name}}',
  media: 'Fotos recebidas',
  mediaHint: 'guardadas hoje; quem revoga leva as suas',
  notifications: 'Notificações entregues',
  notificationsHint: 'no máximo 1 por atleta por dia',
  clicks: 'Cliques em "Ver na {{name}}"',
  clicksHint: '{{gallery}} na galeria · {{media}} nas fotos',
} satisfies TranslationTree;
